const trackEmail = (email: string):void => {
    if(!email) throw new Error("email is mandatory in trackEmail")
    
    if(window.wa && window.wa.bt_queue) {
        window.wa.bt_queue.push({"customIdentifier": email})
    }
} 

export default trackEmail